import { hide, show, toggle } from "slidetoggle";
import { Breakpoints } from "../../breakpoints";

export const slideToggleDefaults = {
  miliseconds: 200,
  transitionFunction: 'linear',
};
export const slideToggle = (el, opts = {}) => {
  toggle(el, { ...slideToggleDefaults, ...opts });
};
export const slideUp = (el, opts = {}) => {
  hide(el, { ...slideToggleDefaults, ...opts });
};
export const slideDown = (el, opts = {}) => {
  show(el, { ...slideToggleDefaults, ...opts });
};
export const isHidden = (el) => el.offsetParent === null;

export const SlideToggle = () => ({
  "x-data": () => ({
    open: false,
  }),
  "@toggle"() {
    this.open = !this.open;
  },
  "@open"() {
    this.open = true;
  },
  "@close"() {
    this.open = false;
  },
  "x-init"() {
    this.$watch('open', (openValue) => {
      if (openValue) slideDown(this.$el);
      else slideUp(this.$el);
    });
    this.open = !isHidden(this.$el);
  }
});

export const SlideToggleNext = () => ({
  "@click"(e) {
    e.preventDefault();
    e.stopPropagation();

    this.open = !this.open;
  },
  "x-data": () => ({
    open: false,
  }),
  "x-init"() {
    this.$watch('open', (openValue) => {
      if (openValue) slideDown(this.$el.nextElementSibling);
      else slideUp(this.$el.nextElementSibling);
    });
    this.open = !isHidden(this.$el.nextElementSibling);
  }
});

export const AccordionToggleNext = () => ({
  ...SlideToggleNext(),
  "@click"(e) {
    e.preventDefault();
    e.stopPropagation();

    this.open = !this.open;

    const otherAccordions = this.$el.closest("nav, .box")?.querySelectorAll(`[x-bind="${SlideToggleBinders.accordionTrigger}"]`);

    otherAccordions?.forEach((accordion) => {
      if (accordion == this.$el) return;
      accordion.dispatchEvent(new CustomEvent("closeElement"));
    })
  },
  "@closeElement"(e) {
    this.open = false;
  },
  "x-init"() {
    this.$watch('open', (openValue) => {
      if (openValue) slideDown(this.$el.nextElementSibling);
      else slideUp(this.$el.nextElementSibling);
    });
    this.open = !isHidden(this.$el.nextElementSibling) || this.$el.parentNode.classList.contains('menu__item--active-trail');
  },
});

export const SlideToggleBinders = [
  ["slideToggle", SlideToggle],
  ["slideToggleNext", SlideToggleNext],
  ["accordionToggleNext", AccordionToggleNext],
];
